import auth from "../../const/auth";
import netcoServer from '../../apis/netcoServer';
import {FORGOT_PASSWORD} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import loadingCall from "../helpers/loadingCall";

const forgotPassword= (formValues) => async (dispatch, getState) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/UserService/forgotPassword', formValues));
  handleResponse(dispatch, response, FORGOT_PASSWORD, data => onSuccessPayload(data, getState), '/');
};

const onSuccessPayload = (data, getState) => {
  return infoPayload('success', auth[getState().auth.language].passwordResetEmailSent.replace('{0}', () => data.mail));
};
export default forgotPassword;